import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PurchaseOrderService } from "src/services";
import { PurchaseOrder } from "src/types";
import { queryKeys } from "src/constants";

export const useUpdatePurchaseOrderPaymentTerms = (purchaseOrderService: PurchaseOrderService) => {
  const queryClient = useQueryClient();
  const [lastVariables, setLastVariables] = useState<{
    purchaseOrderId: string;
    paymentTerms: string | null;
  } | null>(null);

  const updatePurchaseOrderInCache = (updatedPurchaseOrder: PurchaseOrder) => {
    queryClient.setQueryData(queryKeys.purchaseOrder(updatedPurchaseOrder.id), () => updatedPurchaseOrder);
  };

  const {
    mutate: updatePaymentTerms,
    isPending: isUpdatingPaymentTerms,
    error: paymentTermsUpdateError,
    reset: resetPaymentTermsUpdate
  } = useMutation<PurchaseOrder, Error, { purchaseOrderId: string; paymentTerms: string | null }>({
    mutationFn: ({ purchaseOrderId, paymentTerms }) =>
      purchaseOrderService.updatePurchaseOrderPaymentTerms(purchaseOrderId, paymentTerms),
    onSuccess: updatePurchaseOrderInCache,
    onMutate: (variables) => {
      setLastVariables(variables);
    }
  });

  const retryPaymentTermsUpdate = () => {
    if (lastVariables) {
      updatePaymentTerms(lastVariables);
    }
  };

  return {
    updatePaymentTerms,
    isUpdatingPaymentTerms,
    paymentTermsUpdateError,
    retryPaymentTermsUpdate,
    resetPaymentTermsUpdate
  };
};
